<template>
  <img class="v-qrcode" :src="url">
</template>

<script>
import QRCode from "qrcode";
export default {
  props: {
    text: {
      default: ""
    },
    size: {
      default: 256,
      validator(value) {
        return Number(value) > 0;
      }
    },
    level: {
      default: "M",
      validator(value) {
        return ["L", "M", "Q", "H"].includes(value);
      }
    },
    color: {
      default: "#000000"
    },
    bgColor: {
      default: "#ffffff"
    },
    logo: {
      default: ""
    },
    logoSize: {
      default: 36
    },
    scale: {
      default: 2
    }
  },
  data() {
    return {
      url: ""
    };
  },
  watch: {
    ["text"](value) {
      this.generate(value);
    }
  },
  methods: {
    generate() {
      let { size, level, color, bgColor } = this;
      QRCode.toDataURL(
        this.text,
        {
          margin: 0,
          width: size,
          color: {
            dark: color,
            light: bgColor
          },
          errorCorrectionLevel: level
        },
        (e, src) =>
          Object.assign(new Image(), {
            src,
            onload: e => this.drawLogo(e.originalTarget || e.path[0])
          })
      );
    },
    drawQRCode(base64) {
      this.url = URL.createObjectURL(URL.toFile(base64));
    },
    drawLogo(qrcode) {
      let { size, logoSize } = this,
        margin = (size - logoSize) / 2,
        context = Element.create("canvas", {
          width: size,
          height: size
        }).getContext("2d");
      context.drawImage(qrcode, 0, 0, size, size);
      let logo = Object.assign(new Image(), {
        src: this.logo,
        crossOrigin: "Anonymous",
        onload: () => {
          context.fillStyle = "#ffffff";
          context.fillRect(margin, margin, logoSize, logoSize);
          context.drawImage(logo, margin, margin, logoSize, logoSize);
          context.lineWidth = 2;
          context.strokeStyle = "#ffffff";
          context.drawRoundRect(
            margin - 1,
            margin - 1,
            logoSize + 2,
            logoSize + 2,
            4
          );
          context.stroke();
          this.drawQRCode(context.canvas.toDataURL("image/png"));
        },
        onerror: () => this.drawQRCode(context.canvas.toDataURL("image/png"))
      });
    }
  },
  created() {
    this.generate(this.text);
  },
  destroyed() {
    URL.revokeObjectURL(this.url);
  }
};
</script>